(() => {
  const initTabs = (tabs) => {
    if (tabs.dataset.mpReady === 'true') return;

    const buttons = Array.from(tabs.querySelectorAll('[role="tab"]'));
    const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));
    if (!buttons.length || !panels.length) return;

    const activate = (button, focus = false) => {
      const targetId = button.getAttribute('aria-controls');

      buttons.forEach((item) => {
        const active = item === button;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      if (focus) button.focus();
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        activate(buttons[nextIndex], true);
      });
    });

    activate(buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0]);
    tabs.dataset.mpReady = 'true';
  };

  const initLocationPicker = (picker) => {
    if (picker.dataset.mpReady === 'true') return;

    const buttons = Array.from(picker.querySelectorAll('[data-mp-location-target]'));
    const panels = Array.from(picker.querySelectorAll('[data-mp-location-panel]'));
    if (!buttons.length || !panels.length) return;

    const activate = (button, focus = false) => {
      const targetId = button.dataset.mpLocationTarget;
      buttons.forEach((item) => {
        const active = item === button;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      if (focus) button.focus();
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;
        if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        activate(buttons[nextIndex], true);
      });
    });
    activate(buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0]);
    picker.dataset.mpReady = 'true';
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-mp-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-mp-location-picker]').forEach(initLocationPicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
